import { Dialog } from "../../control/Dialog";
import { TitanButton } from "../../control/TitanButton";
import { DialogData } from "../../control/data/DialogData";
import { CommonLang } from "../lang/CommonLang";
import { ViewUtils } from "../../../util/view/ViewUtils";
/**
 * MessageDialog.ts
 */
export class MessageDialog extends Dialog {
    create() {
        super.create();
        this.name = "MessageDialog";
        this.createBackground();
        this.createTitleField();
        this.createMessageField();
        this.createButtons();
    }
    destroy() {
        this.messageDialogProperties = null;
        this.background.destroy({ children: true });
        this.titleField.destroy();
        this.messageField.destroy();
        this.confirmButton.destroy();
    }
    createProperties(properties, portraitProperties) {
        super.createProperties(properties, portraitProperties);
        this.messageDialogProperties = properties;
    }
    createBackground() {
        this.background = this.assetManager.getSprite(this.messageDialogProperties.backgroundProperties);
        this.addChild(this.background);
    }
    createTitleField() {
        this.titleField = ViewUtils.createField(this, this.messageDialogProperties.titleFieldProperties);
    }
    createMessageField() {
        this.messageField = ViewUtils.createField(this, this.messageDialogProperties.messageFieldProperties);
    }
    createButtons() {
        this.createConfirmButton();
    }
    createConfirmButton() {
        this.confirmButton = new TitanButton(this.messageDialogProperties.confirmButtonProperties);
        this.confirmButton.name = "confirmButton";
        this.confirmButton.onClick(this.handleConfirmButtonSelected, this);
        this.addChild(this.confirmButton);
    }
    handleConfirmButtonSelected() {
        this.handleConfirm();
    }
    update(data) {
        super.update(data);
        this.updateTitle();
        this.updateMessage();
        this.updateButtons();
    }
    updateTitle() {
        let title = this.data.getLang(CommonLang.DIALOG_TITLE);
        if (title) {
            this.titleField.setText(title, true);
        }
        else {
            this.titleField.clear();
        }
    }
    updateMessage() {
        let message = this.data.getLang(CommonLang.DIALOG_MESSAGE);
        this.messageField.setText(message, true);
    }
    updateButtons() {
        this.updateButton(this.confirmButton, DialogData.CONFIRM, CommonLang.OK_BUTTON);
    }
    updateButton(button, key, defaultKey) {
        if (button) {
            button.resetOverState();
            let buttonKey = this.data.hasButtonLang(key) ? this.data.getButtonLang(key) : defaultKey;
            button.setLangKey(buttonKey, true);
        }
    }
}
//# sourceMappingURL=MessageDialog.js.map